export default {
    goToTop () {
        $('body,html').animate({
            scrollTop : 0
        }, 100);
    },
    limitLength (text) {
        if(text && text.length > 600) {
            return text.substring(0,600) + '...'
        } else {
            return text
        }
    },
    checkForBenefitsOrTestimonials (articles, string) {
        let arr = []
        for (let article of articles) {
          if (article.Home_options && article.Home_options.includes(string)) arr.push(article)
        }
        return arr
    },
    removeBenefitsAndTestimonials (articles) {
        return articles.filter(article => !article.Home_options)
    },
    initializeCarousel () {
        $(document).ready(function () {
              var mySwiper = new Swiper ('.partners-carousel', {
                // Optional parameters
                loop: true,
                speed: 500,
                breakpoints: {
                    1750: {
                        slidesPerView: 4
                    },
                    1350: {
                        slidesPerView: 3
                    },
                    1050: {
                        slidesPerView: 2
                    },
                    550: {
                        slidesPerView: 1
                    }
                },
                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            })
        })
    },
    initializeSecondCarousel () {
        $(document).ready(function () {
              var mySwiper = new Swiper ('.testimonials-carousel', {
                // Optional parameters
                loop: true,
                speed: 1000,
                slidesPerView: 1,
                autoplay: {
                    delay: 5000
                },
            })
        })
    }
}